import React, { useEffect, useContext, useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles, darken } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import { useSelector, useDispatch } from "react-redux";
import BrandLogo from "../../assets/images/jetpress-logo-white.svg";
import BrandLogoLight from "../../assets/images/jetpress-logo-dark.svg";
import { useHistory, Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Hidden,
  Divider,
  ListItemIcon,
  Button,
  MenuItem,
  Menu,
  ClickAwayListener,
  FormControl,
  InputLabel,
  Select,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import LanguageSelector from "../internationalization/index";
import { MasterContext } from "../../context/master";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: 120,
  },
  toolbarSpacer: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("lg")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    /* [theme.breakpoints.up("lg")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth
    },*/
    background: theme.palette.appBarBackground.main,
    color: theme.palette.appBarForeground.main,
  },
  menuButton: {
    //marginRight: theme.spacing(2),
    /*[theme.breakpoints.up("lg")]: {
      display: "none"
    }*/
  },
  toolbar: {
    ...theme.mixins.toolbar,
    display: "flex",
    alignItems: "center",
  },
  brand: {
    flex: "auto",
    minHeight: 100,
    marginTop: theme.spacing(3),
    background:
      theme.palette.type === "dark"
        ? `url(${BrandLogo})`
        : `url(${BrandLogoLight})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.palette.drawerBackground.main,
    color: theme.palette.drawerForeground.main,
    "& span": {
      color: theme.palette.drawerForeground.main,
    },
    "& ul > .MuiListItem-button:hover": {
      background:theme.palette.type === "dark" ? "rgba(255,255,255,0.60)"   : "rgba(0,0,0,0.40)",
    },
    "& ul > .MuiListItem-button.Mui-selected": {
      background: theme.palette.type === "dark" ? "rgba(255,255,255,0.45)"  : "rgba(0,0,0,0.35)",
    },
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    color: theme.palette.textLight.main,
  },
}));

function ButtonAppBar(props) {
  const history = useHistory();
  const { container } = props;
  const classes = useStyles();
  const theme = useSelector((state) => state.theme);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const userAccess = useSelector((state) => state.userAccess);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const { t } = useTranslation();
  const drawer = (
    <div>
      <div className={classes.toolbar}>
        <div
          className={classes.brand}
          onClick={() => {
            history.push("/my-websites");
            document.documentElement.clientWidth <= 1263 &&
              setMobileOpen(!mobileOpen);
          }}
        ></div>
      </div>
      <List>
        <ListItem
          onClick={() => {
            history.push("/dashboard");
            document.documentElement.clientWidth <= 1263 &&
              setMobileOpen(!mobileOpen);
          }}
          selected={history.location.pathname === "/dashboard"}
          button
        >
          <ListItemIcon>
            <Icon>dashboard</Icon>
          </ListItemIcon>
          <ListItemText primary={t("Dashboard")}></ListItemText>
        </ListItem>
        <ListItem
          onClick={() => {
            history.push("/my-websites");
            document.documentElement.clientWidth <= 1263 &&
              setMobileOpen(!mobileOpen);
          }}
          selected={history.location.pathname.includes("/my-websites")}
          button
        >
          <ListItemIcon>
            <Icon>web</Icon>
          </ListItemIcon>
          <ListItemText primary={t("My Websites")}></ListItemText>
        </ListItem>
      </List>
    </div>
  );
  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <Icon>menu</Icon>
          </IconButton>
          <div>
            <div className={classes.headerContent}>
              <Typography variant="h6" className={classes.title}>
                {t(props.title)}
              </Typography>
              <Divider
                orientation="vertical"
                style={{ margin: "0px 10px" }}
                flexItem
              />
              <Typography variant="h6" className={classes.title}>
                {t("Customer ID")} : {userAccess.customerID}
              </Typography>
            </div>
          </div>
          <div className={classes.toolbarSpacer}></div>
          <LanguageSelector />
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>

        {/*
        <Hidden lgUp implementation="css">
        </Hidden>
        <Hidden mdDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>*/}
      </nav>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
}
export default ButtonAppBar;
